import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';
import { HelpCenter } from '@nucleus-commerce/admin-kit/tour';

import { PLATFORM_TOUR_GROUPS } from '../definitions';

function Help() {
  const { tour: deepLink } = useSearch({ from: '/_authed/help' });
  const navigate = useNavigate({ from: '/help' });
  const clearDeepLink = useCallback(
    () => navigate({ search: (prev) => ({ ...prev, tour: undefined }), replace: true }),
    [navigate],
  );
  return (
    <HelpCenter
      groups={PLATFORM_TOUR_GROUPS}
      targets={{
        progress: 'platform.help.progress',
        search: 'platform.help.search',
        groups: 'platform.help.groups',
        restart: 'platform.help.restart',
      }}
      deepLinkTourId={deepLink}
      onDeepLinkHandled={clearDeepLink}
    />
  );
}

export function HelpCenterPage() {
  return (
    <FeatureErrorBoundary name="tours.help">
      <Help />
    </FeatureErrorBoundary>
  );
}
